import { Logo } from '@/assets/logo';

export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center">
      <Logo className="h-16 w-16 mb-6 animate-bounce" />
      <div className="relative">
        <div className="h-2 w-32 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-primary rounded-full animate-progress" />
        </div>
      </div>
    </div>
  );
}